import gql from "graphql-tag";
import PropTypes from "prop-types";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query companies(
      $companyId: ID
      $companyName: String
      $rowFrom: Int
      $rowTo: Int
    ) {
      companies(
        companyId: $companyId
        companyName: $companyName
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) {
        id: companyId
        companyName
        companyFullName
        inn
        currentRow
        totalRows
      }
    }
  `,
  variables: ({ companyId, companyName, page = 1, itemsPerPage = 10 }) => {
    const firstItem = (page - 1) * itemsPerPage || 1;
    const lastItem = firstItem + itemsPerPage;
    return {
      companyId,
      companyName,
      rowFrom: firstItem,
      rowTo: lastItem,
    };
  },
  config: {
    // errorPolicy: "none",
    pollInterval: 0,
    fetchPolicy: "network-only",
  },
  propTypes: {
    companyId: PropTypes.string,
    companyName: PropTypes.string,
    page: PropTypes.number,
    itemsPerPage: PropTypes.number,
  },
  dataKey: "companies",
  sort: (items) => sortby(items, (o) => parseInt(o.id, 10)),
  getTotal: (items) => (items && items.length ? items[0].totalRows : null),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/companies.js